module.exports = __webpack_public_path__ + "img/YouLostMail_1920x1080.351fa9ff.png";